import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import AboutUs from '@/components/AboutUs/AboutUs'
import synopsis from '@/components/AboutUs/synopsis'
import expert from '@/components/AboutUs/expert'
import quality from '@/components/AboutUs/quality'
import culture from '@/components/AboutUs/culture'
import service from '@/components/service/service'
import cro from '@/components/service/cro'
import cdmo from '@/components/service/cdmo'
import pharmacy from '@/components/service/pharmacy'
import NewsCenter from '@/components/NewsCenter/NewsCenter'
import news from '@/components/NewsCenter/news'
import detail from '@/components/NewsCenter/detail'
import product from '@/components/product/product'
import productdetail from '@/components/product/productdetail'
import prodetail from '@/components/product/prodetail'
import second from '@/components/product/second'
import about from '@/components/about/about'
import aboutdetail from '@/components/about/aboutdetail'
import contact from '@/components/contact/contact'
import search from '@/components/search/search'
// 避免到当前位置的冗余导航
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'index',
			component: index
		},
		{
			path: '/AboutUs',
			component: AboutUs,
			children: [
				{
					path: '/AboutUs/synopsis',
					name: 'synopsis',
					component: synopsis
				},
				{
					path: '/AboutUs/expert',
					name: 'expert',
					component: expert
				},
				{
					path: '/AboutUs/quality',
					name: 'quality',
					component: quality
				},
				{
					path: '/AboutUs/culture',
					name: 'culture',
					component: culture
				}
			]
		},
		{
			path: '/service',
			component: service,
			children: [{
					path: '/service/cro',
					name: 'cro',
					component: cro
				},
				{
					path: '/service/cdmo',
					name: 'cdmo',
					component: cdmo
				},
				{
					path: '/service/pharmacy',
					name: 'pharmacy',
					component: pharmacy
				}
			]
		},
		{
			path: '/NewsCenter',
			component: NewsCenter,
			children: [{
					path: '/NewsCenter/news:type',
					name: 'news',
					component: news
				},
				{
					path: '/NewsCenter/detail:id',
					name: 'detail',
					component: detail
				}
			]
		},
		{
			path: '/product',
			name: 'product',
			component: product
		},
		{
			path: '/product/second',
			name: 'second',
			component: second
		},
		{
			path: '/product/productdetail',
			name: 'productdetail',
			component: productdetail
		},
		{
			path: '/product/prodetail',
			name: 'prodetail',
			component: prodetail
		},
		{
			path: '/about',
			name: 'about',
			component: about
		},
		{
			path: '/about/aboutdetail',
			name: 'aboutdetail',
			component: aboutdetail
		},
		{
			path: '/contact',
			name: 'contact',
			component: contact
		},
		{
			path: '/search',
			name: 'search',
			component: search
		},
	],
	// return 期望滚动到哪个的位置
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
				 return savedPosition
		} else {
		 // vue2.0  x  y  控制
		 // vue3.0  left  top 控制
		return { x: 0, y: 0 }
		}
	}
})



// WEBPACK FOOTER //
// ./src/router/index.js